<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير الحضور والغياب لليوم'" :to="{name: 'reports.absences_day'}">  تقرير الحضور والغياب لليوم</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تقرير الحضور والغياب لليوم
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                      <div class="col-md-6 mt-2">
                                          <label for=""> التاريخ  <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                         <div class="col-md-6 mt-2">
                                          <label for=""> نوع البيانات <span class="text-danger">*</span></label>
                                          <select name="type" id="tt" v-model="data.searching.type" class="form-control">
                                            <option value="presence">حضور</option>
                                            <option value="absence">غائب</option>
                                            <option value="delay">تأخير</option>
                                            <option value="excuse">استأذان</option>
                                          </select>
                                        </div>

                                         <div class="col-md-6 mt-2">
                                          <label for="">الحلقة</label>
                                          <treeselect :options="lessons" v-model="data.searching.lesson_id" :multiple="false" />
                                        </div>
                                      
                                       
                                        
                                        <div class="col-md-4 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive" >
                                  <div class="col-md-12 mb-2">
                                    <button class="btn btn-success" v-if="data.data.length" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  <button class="btn btn-success ml-2" v-if="(data.data && data.data.length > 0)" @click.prevent="exportDailyAttendanceExcel">
                                    تصدير Excel
                                  </button>
                                  </div>
                                  <div class="col-md-12" id="printMe">
                                    <table class="table table-bordered mb-4" v-if="data.data.length">
                                    <thead>
                                           <tr>
                                            <th>اسم التقرير</th>
                                            <th >التاريخ </th>
                                            <th>النوع </th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>تقرير الحضور والغياب لليوم</td>
                                            <td >
                                              {{ data.searching.date_from }}
                                            </td>
                                            <td>
                                              {{ getType() }}
                                            </td>
                                          </tr>
                                        </tbody>
                                  </table>

                                  <table class="table table-bordered mb-4" v-if="data.data.length">
                                        <thead>
                                           <tr>
                                            <th>التاريخ</th>
                                            <th>الطالب</th>
                                            <th>الحلقة</th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(deg, i) in data.data" :key="i">
                                            <td>{{ deg.dt }}</td>
                                            <td>{{ deg.student }}</td>
                                            <td>{{ deg.lesson }}</td>
                                          
                                          </tr>
                                          
                                        </tbody>
                                    </table>
                                  </div>
                                  <div class="col-md-12">
                                    <button class="btn btn-success" v-if="data.data.length" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                   <button class="btn btn-success ml-2" v-if="(data.data && data.data.length > 0)" @click.prevent="exportDailyAttendanceExcel">
                                    تصدير Excel
                                  </button>
                                  </div>
                                 
                                    
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapGetters } from 'vuex'
import * as XLSX from "xlsx";

export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      isRequested: false,

      chartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            labels: ['اجمالى الحضور', 'اجمالى الغياب', 'اجمالى الاستأذان', 'اجمالى التأخير'],
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            legend: {
              formatter: function(val, opts) {
                return val + " - " + opts.w.globals.series + '%'
              }
            },
            title: {
              text: ''
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      printData: {
      },
      data: {
        data: {},
        info: {},
        total: {},
        searching:{
            group_id: '',
            lesson_id: '',
            type: 'presence',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      // this.search(null, '', this, 'lesson');
      // this.search(null, '', this, 'group');
      this.getOptionsToSearch();
  },
  methods: {
    exportDailyAttendanceExcel() {
      const wb = XLSX.utils.book_new();
      const self = this;

      // =========================
      // Safe Excel sheet name
      // =========================
      function safeSheetName(name) {
        if (!name) return "تقرير اليوم";
        return name.toString().replace(/[\[\]\*\/\\\?\:]/g, "").substring(0, 31);
      }

      const rows = [];

      // ===== Header table =====
      rows.push(["اسم التقرير", "التاريخ", "النوع"]);
      rows.push([
        "تقرير الحضور والغياب لليوم",
        self.data.searching.date_from,
        self.getType()
      ]);
      rows.push([]); // empty row

      // ===== Attendance table =====
      rows.push(["التاريخ", "الطالب", "الحلقة"]);

      if (Array.isArray(self.data.data)) {
        self.data.data.forEach(function (deg) {
          rows.push([
            deg.dt,
            deg.student,
            deg.lesson
          ]);
        });
      }

      // ===== Create worksheet =====
      const ws = XLSX.utils.aoa_to_sheet(rows);

      // RTL support
      ws["!rtl"] = true;

      // Column widths
      ws["!cols"] = [
        { wch: 15 },
        { wch: 25 },
        { wch: 15 }
      ];

      // Append sheet
      XLSX.utils.book_append_sheet(wb, ws, safeSheetName("Daily Attendance"));

      // Save file
      XLSX.writeFile(wb, "daily-attendance-report.xlsx");
    },
    getLabelById(arr, id){
      if(arr.length){
        for (let index = 0; index < arr.length; index++) {
        let element = arr[index];
        if(element.id == id){
          return element.label;
        }
        
      }
      }
      
      return '';
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', 'تقرير الحضور والغياب لليوم');

      }, 3000);
    },
    getType(){
      let arr = {
        'presence':'حضور',
        'absence':'غائب',
        'delay': 'تأخير',
        'excuse': 'استأذان'
      };
      return arr[this.data.searching.type];
    },
      getIndexData(page){
        if(this.data.searching.date_from == '' || this.data.searching.type == ''){
          return;
        }
        this.isRequested = true;
        this.$baseApi.get('/reports/absences-day?data=' + 1, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.data = response.data.data.students;
              this.isRequested = false;
              
            }else{
                alert(response.data.error.error);
                this.isRequested = false;

            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return (n/t) * 100;
    },
    getOptionsToSearch(){
      this.$baseApi.get('/reports/absences-day?pluck=' + 1).then((response)=>{
            if(response.data.code == 200){
              this.lessons = response.data.data.lessons;
              
            }else{
                alert(response.data.error.error);
            }
        });
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    ...mapGetters({
      settings: 'GET_WEBSITE_SETTING_KEYS'
    })
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
